import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from 'syf-component-library/defaultTheme';
import { useTranslation } from 'react-i18next';
import { FAR_MAGNIFYING_GLASS } from '../../../../../const/icons';
import InputTextfield from './subcomponents';
var InputSearch = function (_a) {
    var onChange = _a.onChange, value = _a.value;
    var t = useTranslation().t;
    return (_jsx(InputTextfield, { className: "input-search", id: "certificate-history-search", leftIcon: _jsx(FontAwesomeIcon, { icon: FAR_MAGNIFYING_GLASS, color: colors.cyanBlue, width: 32 }), onChange: onChange, placeholder: t('certificateHistoryTab.searchCertNum'), type: "text", value: value, width: "312px" }));
};
export default InputSearch;
